export default __webpack_public_path__ + "static/media/money-transfer.e2168b5a.png";